import { render, staticRenderFns } from "./ContractForm.vue?vue&type=template&id=28f988b4&scoped=true"
import script from "./ContractForm.vue?vue&type=script&lang=js"
export * from "./ContractForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f988b4",
  null
  
)

export default component.exports